import React, { useState, useEffect } from 'react'
import {
  Button,
  Container,
  Css,
  HtmlContent,
  Popup,
  TextTitle,
  TextBody,
  Link,
  Checkbox
} from '@pmi/pmi-iqos-ds-react'
import { htmlTranslation } from '@pmi/pmi-iqos-shared-react'

const TermsPopup = ({
  isOpen,
  onClose,
  onAccept,
  content,
  loading,
  translations
}) => {
  const [disableButton, setDisableButton] = useState(true)
  const [toggleTerms, setToggleTerms] = useState(false)

  useEffect(() => {
    window.addEventListener('resize', isTermsRead)
    return () => {
      window.removeEventListener('resize', isTermsRead)
    }
  }, [])

  const handleScroll = e => {
    isTermsRead(
      e.target.scrollHeight,
      e.target.scrollTop,
      e.target.clientHeight
    )
  }

  const isTermsRead = (scrollHeight, scrollTop, clientHeight) => {
    let termsRead
    if (scrollHeight && scrollTop && clientHeight) {
      termsRead = Math.abs(scrollHeight - clientHeight - scrollTop) < 1
    } else {
      const element = document.getElementById(
        'AddressConfirmation_TermsContent'
      )
      termsRead =
        element &&
        element.scrollHeight - element.scrollTop === element.clientHeight
    }
    if (disableButton && termsRead) setDisableButton(false)
  }

  return (
    <Popup
      isOpen={isOpen}
      onCloseHandler={onClose}
      blocking
      data-testing-prefix="AddressConfirmation">
      <Container
        flexDirection={Container.flexDirections.column}
        display={Container.displays.flex}
        justifyContent={[
          Container.justifyContentValues.start,
          Container.justifyContentValues.between
        ]}>
        <Container pb="6">
          <Container pb="2">
            <TextTitle
              heading={TextTitle.headings.h2}
              data-testing="AddressConfirmation_TextTitle_TitleLabel">
              {translations.tk_popupTitle}
            </TextTitle>
          </Container>
          <Container>
            <TextBody size={TextBody.sizes.l}>
              {translations.tk_popupDescription}
            </TextBody>
          </Container>
        </Container>
        <Css
          s={{
            'div:first-of-type': {
              maxHeight: 'calc(100svh - 500px)'
            }
          }}>
          <Container
            id="AddressConfirmation_TermsContent"
            bg={Container.backgrounds.hardWhite}
            p="8"
            overflow
            onScrollHandler={handleScroll}
            refValue={e => {
              if (e) isTermsRead(e.scrollHeight, e.scrollTop, e.clientHeight)
            }}>
            <HtmlContent content={content && content} />
          </Container>
        </Css>
        <Container
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}
          alignItems={Container.alignItemsValues.center}
          pt="10">
          <Css s={{ maxHeight: '50px' }}>
            <Container
              display={Container.displays.flex}
              justifyContent={Container.justifyContentValues.center}
              pb="4">
              <Checkbox
                name="AgreeToTerms"
                checked={toggleTerms}
                onChangeHandler={() => setToggleTerms(!toggleTerms)}
                template={
                  <TextBody
                    breakWords
                    {...htmlTranslation(translations, 'tk_popupCheckboxText')}
                  />
                }
                data-testing="Address_Confirmation_Checkbox_Terms"
              />
            </Container>
          </Css>
          <Button
            variant={Button.variants.primary}
            text={translations.tk_popupSubmitBtn}
            onClickHandler={onAccept}
            loading={loading}
            disabled={disableButton || !toggleTerms}
            data-testing="Address_Confirmation_Button_AcceptTerms"
          />
          <Container pt="4">
            <Link onClickHandler={onClose}>
              {translations.tk_popupCancelBtn}
            </Link>
          </Container>
        </Container>
      </Container>
    </Popup>
  )
}

export default TermsPopup
